import { render, staticRenderFns } from "./IRepeat.vue?vue&type=template&id=1fd3a6d4&scoped=true&"
import script from "./IRepeat.vue?vue&type=script&lang=js&"
export * from "./IRepeat.vue?vue&type=script&lang=js&"
import style0 from "./IRepeat.vue?vue&type=style&index=0&id=1fd3a6d4&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3a6d4",
  null
  
)

export default component.exports